
import { getStyleList, getStyleInfo, copyStyle, deleteStudyStyle } from '@/api/Allservices'
import { Component, Vue, Watch } from 'vue-property-decorator'
@Component({
  components: {},
})
export default class StudyStyleLibrary extends Vue {
  visible = false
  loading = false
  CurrConfig: any = null
  conditions = {
    limit: 8,
    skip: 0,
    customer_id: 0,
  }
  styleList = []
  count = 0
  page = 1
  types: any = {}
  size: any = {}
  listKeyword = this.$route.query.search || ''

  get org() {
    return this.$store.state.user?.orgs[0]?.orgId || 0
  }

  get fileType() {
    return this.$route.query.fileType
  }

  get selectedType() {
    const { type, fileType } = this.$route.query
    const key = Object.keys(this.types).find(k => this.types[k] === type)
    return fileType || key || '全部'
  }

  get selectedSize() {
    const { size } = this.$route.query
    const key = Object.keys(this.size).find(k => this.size[k] === size)
    return key || '全部'
  }

  get wordToFbdTypes() {
    return (this.$store.state.user?.orgs[0]?.wordToFbdTypes || '').split(',')
  }

  async created() {
    await this.getStyleInfo()
    this.conditions.customer_id = this.org

    await this.getList()
    if(this.styleList.length === 0) {
      this.conditions.customer_id = 0
    }
  }

  @Watch('conditions', { deep: true })
  async getList() {
    this.loading = true
    try {
      const { size, search } = this.$route.query
      const res = await getStyleList({
        type: this.types[this.selectedType as string] || 'all',
        size: size || 'all',
        search,
        ...this.conditions,
      })
      if(this.conditions.customer_id === 0) {
        this.styleList = res.data.sort((a: any, b: any) => {
          const getFormatInfo = (name: string) => {
            const sizeMatch = name.match(/(16K|8K)/);
            const columnMatch = name.match(/(\d+)栏/);

            const size = sizeMatch ? sizeMatch[1] : '';
            const column = columnMatch ? parseInt(columnMatch[1]) : 0;

            // 尺寸优先级：16K 优先于 8K
            const sizePriority = size === '16K' ? 0 : 1;

            return { size, column, sizePriority };
          };

          const infoA = getFormatInfo(a.name);
          const infoB = getFormatInfo(b.name);

          // 先按尺寸排序
          if (infoA.sizePriority !== infoB.sizePriority) {
            return infoA.sizePriority - infoB.sizePriority;
          }

          // 同尺寸下按栏数排序
          return infoA.column - infoB.column;
        });
      } else {
        this.styleList = res.data
      }
      this.count = res.count
      this.loading = false
    } catch (error) {
      this.loading = false
    }
  }

  handleType(command: string) {
    const { type } = this.$route.query
    if (type !== command) {
      this.$router.replace({ query: { ...this.$route.query, type: command } })
      this.getList()
    }
  }

  handleSize(command: string) {
    const { size } = this.$route.query
    if (size !== command) {
      this.$router.replace({ query: { ...this.$route.query, size: command } })
      this.getList()
    }
  }

  async getStyleInfo() {
    const { type, size } = await getStyleInfo({})
    const types: any = {}
    if (this.wordToFbdTypes.length) {
      this.wordToFbdTypes.forEach((item: string) => {
        const keys = Object.keys(type)
        const values = Object.values(type)
        if (values.includes(item)) {
          types[keys[values.findIndex(v => v === item)]] = item
        }
      })
      this.types = { 全部: 'all', ...types }
    } else {
      this.types = { 全部: 'all', ...type }
    }
    this.size = size
  }

  searchList(val: string) {
    this.$router.replace({ query: { ...this.$route.query, search: val } })
    this.getList()
  }

  async creatStyle(id?: number) {
    if (id) {
      this.$router.push({
        path: '/style-demo-fbd',
        query: {
          ...this.$route.query,
          style_id: id + '',
        },
      })
    } else {
      this.$router.push({
        path: '/style-demo-fbd',
        query: {
          ...this.$route.query,
        },
      })
    }
  }

  handleStyle(id: number) {
    this.$emit('save', id)
  }

  async deleteStyle(id?: number) {
    this.$confirm('是否删除此模板？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteStudyStyle({
          _id: id,
        })
        await this.getList()
        this.$message.success('删除成功')
      });
  }

  async CopyStyle(_id: string) {
    await copyStyle({
      _id,
    })
    this.$message.success('复制成功')
    this.getList()
  }

  customerIdChange (id: number) {
    console.log(id);
    this.conditions.skip = 0;
    this.page = 1;
  }
}
